import {Actions} from '../../actions';
import {connect} from 'react-redux';
import Resources from '../../components/DiversityPE/Resources';

const mapStateToProps = (state, ownProps) => {
    return {
        diversitype: state.diversitype,
        ...ownProps
    };
};

export default connect(mapStateToProps, Actions)(Resources);
